<template>
  <div class="zz-upload">
    <div class="zz-upload-file" v-for="(file,index) in fileList" :key="index">
      <a :href="file.url" target="_blank" class="image">
        <i class="zz-upload-del" @click="delFile($event,index)"></i><img :src="file.url" />
      </a>
    </div>
    <a href="javascript:;" class="zz-upload-file zz-upload-btn" v-if="maxLength>fileList.length">
      <img src="@/assets/images/feedback_pic.png" class="cloud-upload">
      <img>
      <input
        type="file"
        name="image"
        :accept="accept"
        :value="url"
        @change="handleChangeFile"
        v-if="multiple"
        multiple/>
      <input type="file" name="image"  :accept="accept" @change="handleChangeFile" v-else/>
    </a>
     <a-progress :percent="percent" v-if="progress"/>
  </div>
</template>

<script>
import {  mapGetters } from 'vuex'
import compress from '@/utils/compress'
import axios from 'axios'
export default {
  name: 'FeedbackUpload',
  computed: {
    ...mapGetters(['lang'])
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    url: {
      type: String,
      default: ''
    },
    compress: {
      type: Boolean,
      default: true
    },
    token: {
      type: String,
      default: ''
    },
    progress: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      fileList: this.value,
      percent: 0
    }
  },
  watch: {
    value: function (val) {
      this.fileList = val
    }
  },
  created () {},
  methods: {
    delFile (e, index) {
      e.preventDefault()
      this.fileList = this.fileList
        .slice(0, index)
        .concat(
          this.fileList.slice(
            index + 1,
            this.fileList.length
          )
        )
      this.$emit('input', this.fileList)
      this.$emit('change', this.fileList)
    },
    handleChangeFile (e) {
      this.percent = 0
      this.changeImgs(e.target.files)
    },
    changeImgs (files) {
      var imageFiles = []
      var otherFiles = []
      if (files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          if (files[i].type.indexOf('image') >= 0) {
            imageFiles.push(files[i])
          } else {
            otherFiles.push(files[i])
          }
        }
      }
      if (otherFiles.length > 0) {
        if (this.maxLength >= otherFiles.length) {
          otherFiles.forEach((_, index) => {
            this.upload(otherFiles[index])
          })
        }else {
          this.$toast(this.lang.feedback.upload.uploadMax + this.maxLength + this.lang.feedback.upload.reselectImg)
          return
        }
      }
      if (imageFiles.length > 0) {
        if (this.maxLength >= imageFiles.length) {
          compress(imageFiles, (_, compressFiles) => {
            compressFiles.forEach((_, index) => {
              this.upload(compressFiles[index])
            })
          })
        } else {
          this.$toast(this.lang.feedback.upload.uploadMax + this.maxLength+ this.lang.feedback.upload.reselectImg)
          return
        }

      }
    },
    upload (file) {
      const formData = new FormData()
      formData.append('upfile', file)
      formData.append('name', file.name)
      formData.append('ftype', 'image')
      formData.append('token', this.token)
      var options = {
        headers: {
          'Content-Type': 'multipart/form-data',
          // 'Authorization': 'Bearer ' + this.$ls.get('Access-Token')
        }
      }
      if (this.progress) {
        options.onUploadProgress = (progressEvent) => {
          if (progressEvent.lengthComputable) {
            var percent =
                    (((progressEvent.loaded / progressEvent.total) * 100) | 0)
            this.percent = percent
            this.$emit('progesss', percent)
          }
        }
      }
      let url = window.apiUrl + '/customer/upload/customerImage'
      axios.post(url, formData, options).then(res => {
        if (this.multiple) {
          this.fileList.push(res.data.data)
        } else {
          this.fileList = [res.data.data]
        }
        this.$emit('input', this.fileList)
        this.$emit('change', this.fileList)
      })
    }
  }
}
</script>

<style lang="scss">
 .zz-upload{
   display: flex;
   flex-wrap: wrap;
   .zz-upload-file{
      width:80px;
      height:80px;
      border:1px dashed  #d9d9d9;
      border-radius: 5px;
      margin-right:15px;
      margin-bottom: 15px;
      &.zz-upload-btn{
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fafafa;
        overflow: hidden;
        color: #ffffff;
        text-decoration: none;
        text-indent: 0;
        text-decoration: none;
        input {
            position: absolute;
            width:100px;
            height:100px;
            right: 0;
            top: 0;
            opacity: 0;
        }
      }
      .file{
         position: relative;
        display: flex;
        align-items: center;
        flex-direction: column;
        position: relative;
        .zz-upload-del{
           top: -10px;
          right: -10px;
        }
        .zz-upload-icon{
          margin-top:20px;
          font-style: normal;
          background-repeat: no-repeat;
          background-size: contain;
          width: 40px;
          height: 40px;
          overflow: hidden;
          display: block;
          &.pkg{
             background-image: url(https://static.zhuziplay.com/icon/icon-zip.png);
          }
          &.file{
             background-image: url(https://static.zhuziplay.com/icon/icon-zip.png);
          }
           &.video{
             background-image: url(https://static.zhuziplay.com/icon/icon-zip.png);
          }
        }
        .zz-upload-name{
          font-size:12px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width:80px;
          text-align: center;
        }
      }
      .cloud-upload{
        width: 50px;
        height: 50px;
      }
      .image{
        position: relative;
        .zz-upload-del{
          right: -10px;
        }
        img{
          width:78px;
          height:78px;
        }
      }

    }

 }

.zz-upload-del {
    position:absolute;
     background-repeat: no-repeat;
    background-size: contain;
    width: 20px;
    height: 20px;
    background-image: url(https://static.zhuziplay.com/icon/icon-del.png)
}
</style>
